import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import _ from "lodash";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Badge,
  Card,
  CardBody
} from "reactstrap";
import TitleBar from "../_common/TitleBar";
import { notifLayouts } from "./notifLayoutHelper";
import { actionScripts } from "../../_helpers/actionScripts";
import userActions from "../../_actions/userActions";

const NotifCenterModal = ({ isOpen, toggle }) => {
  const dispatch = useDispatch();
  const [sortColumn] = useState({ path: "raisedOn", order: "desc" });
  const notifications = useSelector(
    (state) => state.authentication.user?.notifications || []
  );

  const sortedData = useMemo(() => {
    return _.orderBy(notifications, [sortColumn.path], [sortColumn.order]);
  }, [notifications, sortColumn]);

  const renderAction = (notif) => {
    return (
      <div className="d-flex" style={{ width: "80px" }}>
        {notif.notificationType === "ADR_SUBMITTED" || notif.notificationType === "ADR_REJECTED" ? (
          <Button
            color="primary"
            size="sm"
            className="flex-grow-1"
            onClick={() => {
              dispatch(userActions.dismissNotification(notif.notificationId));
              actionScripts.OPEN_ADR_LIST.run(notif.projectId);
              toggle();
            }}
          >
            Review
          </Button>
        ) : null}

        {notif.notificationType === "ADR_APPROVED" || notif.notificationType === "PROJECT_ASSIGNED" ? (
          <Button
            color="secondary"
            size="sm"
            className="flex-grow-1"
            onClick={() => {
              dispatch(userActions.dismissNotification(notif.notificationId));
            }}
          >
            Dismiss
          </Button>
        ) : null}
      </div>
    );
  };

  const dismissAllNotifications = () => {
    notifications.forEach((notif) =>
      dispatch(userActions.dismissNotification(notif.notificationId))
    );
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Notification Center
        {sortedData.length > 0 && (
          <div style={{ marginTop: 10 }}>
            <Button color="secondary" onClick={dismissAllNotifications}>
              Dismiss All
            </Button>
          </div>
        )}
      </ModalHeader>
      <ModalBody className="bg-light">
        {sortedData.length > 0 ? (
          sortedData.map((n, index) => (
            <Card key={`notifKey_${index}`} className="mb-2 border-gray">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <Badge color={notifLayouts[n.notificationType].color}>
                    {notifLayouts[n.notificationType].badgeText}
                  </Badge>
                  <small className="text-muted">
                    {notifLayouts[n.notificationType].notifSince(n)}
                  </small>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">{n.title}</h5>
                  <div className="d-flex gap-2">
                    {renderAction(n)}
                  </div>
                </div>
              </CardBody>
            </Card>
          ))
        ) : (
          <p className="text-muted">No notifications available.</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NotifCenterModal;
